import a from "@fortawesome/fontawesome-free/css/fontawesome.min.css?inline";
import b from "@fortawesome/fontawesome-free/css/solid.css?inline";

export const styles = a + b;
